<template>
  <div>
    <!-- <configurar-canal-dialog
      :canal-data="associacaoSelecionada"
      :is-configurar-canal-dialog-open.sync="isConfigurarAssociacaoFilaCanalDialogOpen"
      @refetch-data="$emit('refetch-data')"
    /> -->

    <ativar-ou-inativar-associacao-dialog
      :is-ativar-ou-inativar-associacao-dialog-open.sync="isAtivarOuInativarAssociacaoFilaCanalDialogOpen"
      :is-associacao-ativa-mensagem="isAssociacaoAtivaMensagem"
      :loading="loading"
      :close-dialog="closeDialog"
      :confirmar-ativacao-ou-inativacao-da-associacao="confirmarAtivacaoOuInativacaoDaAssociacao"
    />

    <v-data-table
      no-data-text="Sem dados"
      hide-default-footer
      :headers="headers"
      :items="items"
      :item-class="cursorPointer"
      @click:row="selectAssociacao"
    >
      <template #[`item.nome`]="{ item }">
        <div class="d-flex align-center">
          <v-avatar
            :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
            size="32"
          >
            <span :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold`">
              {{ item.canalNome.toUpperCase().charAt(0) }}{{ item.canalNome.toUpperCase().charAt(1) }}
            </span>
          </v-avatar>
          <div class="d-flex flex-column ms-3">
            {{ item.canalNome }}
          </div>
        </div>
      </template>

      <template #[`item.canalTipoNome`]="{ item }">
        <div class="d-flex align-center">
          <div class="d-flex flex-column me-3">
            {{ item.canalTipoNome }}
          </div>
        </div>
      </template>

      <template #[`item.status`]="{ item }">
        <v-chip
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="`${item.ativo ? 'success--text' : 'secondary--text'}`"
          :color="`${item.ativo ? 'success' : 'secondary'}`"
        >
          {{ item.ativo ? 'Ativo' : 'Inativo' }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              v-on="on"
              color="primary"
            >
              <v-icon @click="ativarOuInativarAssociacaoItem(item)">
                {{ icons.mdiDotsVertical }}
              </v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item>
              <v-list-item-title
                role="button"
                class="d-flex align-end"
                @click="openAssociarOuDesassociar"
              >
                <v-icon
                  size="20"
                  class="me-2"
                  small
                >
                  {{ item.ativo ? icons.mdiCloseThick : icons.mdiCheckBold }}
                </v-icon>
                <span class="text-capitalize"> {{ isAssociacaoAtivaMensagem }} </span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mdiCloseThick, mdiDotsVertical, mdiCheckBold } from '@mdi/js'
import { computed, ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
// import ConfigurarCanalDialog from '@/views/fila/tab-canais/ConfigurarCanalDialog.vue'
import AtivarOuInativarAssociacaoDialog from '@/views/ativar-ou-inativar-associacao-dialog/AtivarOuInativarAssociacaoDialog.vue'
import FilaService from '@/services/modules/FilaService'
import useAuthStore from '@/store/auth'
import FuncionalidadesEnum from '@/models/entities/funcionalidade/FuncionalidadesEnum'

export default {
  components: {
    // ConfigurarCanalDialog,
    AtivarOuInativarAssociacaoDialog,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  setup(_, { emit }) {
    const { funcionalidades } = storeToRefs(useAuthStore())

    const possuiAcessoAoUpdateDaAssociacaoEntreFilaECanalDeEmail = computed(() => funcionalidades.value.includes(FuncionalidadesEnum.UpdateFilaCanalEmailId))
    const possuiAcessoAoUpdateDaAssociacaoEntreFilaECanalDeWhatsApp = computed(() => funcionalidades.value.includes(FuncionalidadesEnum.UpdateFilaCanalWhatsAppId))
    const possuiAcessoAoUpdateDaAssociacaoEntreFilaECanalDeAberturaManual = computed(() => funcionalidades.value.includes(FuncionalidadesEnum.UpdateFilaCanalAberturaManualId))
    const possuiAcessoAoUpdateDaAssociacaoEntreFilaECanalDeAutoatendimento = computed(() => funcionalidades.value.includes(FuncionalidadesEnum.UpdateFilaCanalAutoatendimentoId))
    const possuiAcessoAoUpdateDaAssociacaoEntreFilaECanalDeBot = computed(() => funcionalidades.value.includes(FuncionalidadesEnum.UpdateFilaCanalBotId))

    const podeAtualizarAlgumTipoDeCanal = computed(() => (
      possuiAcessoAoUpdateDaAssociacaoEntreFilaECanalDeEmail.value
     || possuiAcessoAoUpdateDaAssociacaoEntreFilaECanalDeWhatsApp.value
     || possuiAcessoAoUpdateDaAssociacaoEntreFilaECanalDeAberturaManual.value
     || possuiAcessoAoUpdateDaAssociacaoEntreFilaECanalDeAutoatendimento.value
     || possuiAcessoAoUpdateDaAssociacaoEntreFilaECanalDeBot.value
    ))

    const isAtivarOuInativarAssociacaoFilaCanalDialogOpen = ref(false)

    const loading = ref(false)
    const filaId = ref(0)
    const canalId = ref(0)
    const isAssociacaoAtiva = ref(undefined)
    const isAssociacaoAtivaMensagem = ref('')

    function ativarOuInativarAssociacaoItem(item) {
      filaId.value = item.filaId
      canalId.value = item.canalId
      isAssociacaoAtiva.value = item.ativo
      isAssociacaoAtivaMensagem.value = item.ativo ? 'inativar' : 'ativar'
    }
    function openAssociarOuDesassociar() {
      isAtivarOuInativarAssociacaoFilaCanalDialogOpen.value = true
    }
    function closeDialog() {
      isAtivarOuInativarAssociacaoFilaCanalDialogOpen.value = false
    }
    async function confirmarAtivacaoOuInativacaoDaAssociacao() {
      if (loading.value) return
      try {
        loading.value = true
        await FilaService.ativarOuInativarAssociacaoEntreFilaECanal(filaId.value, canalId.value, { ativar: !isAssociacaoAtiva.value })
        emit('refetch-data')
      } finally {
        closeDialog()
        loading.value = false
      }
    }

    const isConfigurarAssociacaoFilaCanalDialogOpen = ref(false)
    const associacaoSelecionada = ref(null)

    function selectAssociacao(item) {
      if (!item.ativo) return
      associacaoSelecionada.value = {
        filaId: item.filaId,
        canalId: item.canalId,
        canalTipoId: item.canalTipoId,
        canalNome: item.canalNome,
        canalDescricao: item.canalDescricao,
        ativo: item.ativo,
      }
      isConfigurarAssociacaoFilaCanalDialogOpen.value = true
    }

    const headers = [
      { text: 'NOME', value: 'nome' },
      { text: 'Tipo Canal', value: 'canalTipoNome' },
      { text: 'STATUS', value: 'status' },
      {
        text: 'OPÇÔES',
        value: 'actions',
        align: 'center',
      },
    ]

    return {
      possuiAcessoAoUpdateDaAssociacaoEntreFilaECanalDeWhatsApp,
      isAtivarOuInativarAssociacaoFilaCanalDialogOpen,
      loading,
      isAssociacaoAtiva,
      isAssociacaoAtivaMensagem,
      ativarOuInativarAssociacaoItem,
      openAssociarOuDesassociar,
      closeDialog,
      confirmarAtivacaoOuInativacaoDaAssociacao,
      isConfigurarAssociacaoFilaCanalDialogOpen,
      associacaoSelecionada,
      selectAssociacao,
      icons: {
        mdiCloseThick,
        mdiDotsVertical,
        mdiCheckBold,
      },
      headers,
      cursorPointer: item => (item.ativo && podeAtualizarAlgumTipoDeCanal.value ? 'cursor-pointer' : ''),
    }
  },
}
</script>
